import { motion } from "framer-motion";
import { fadeUp, stagger } from "@/lib/motion";
import { IMAGES } from "@/lib/content";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-ink-950 py-28 md:py-40 border-t border-ivory/[0.06]"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={stagger}
          className="grid grid-cols-12 gap-6 md:gap-12"
        >
          <motion.div variants={fadeUp} className="col-span-12 md:col-span-5 lg:col-span-4">
            <div className="font-mono-caps text-[10px] text-copper mb-6">
              <span className="mr-3">§ 01</span> About Parin
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ivory">
              Architect.<br />
              <span className="italic text-copper">Developer.</span><br />
              Entrepreneur.
            </h2>
            <div className="mt-10 h-[1px] w-24 bg-copper/60" />
            <p className="mt-10 font-mono-caps text-[10px] text-ivory/50">Portrait / on site · 2025</p>
          </motion.div>

          <motion.div
            variants={fadeUp}
            className="col-span-12 md:col-span-3 lg:col-span-3 order-3 md:order-none"
          >
            <div className="relative clip-frame border border-ivory/10 aspect-[3/4] overflow-hidden bg-ink-900 group">
              <img
                src={IMAGES.portrait}
                alt="Parin Majithia — portrait"
                loading="lazy"
                className="h-full w-full object-cover object-center grayscale group-hover:grayscale-0 scale-[1.02] group-hover:scale-100 transition-all duration-1000 ease-out"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-ink-950/50" />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-copper/0 group-hover:ring-copper/40 transition-[box-shadow] duration-700" />
              {["top-3 left-3", "top-3 right-3", "bottom-3 left-3", "bottom-3 right-3"].map((p) => (
                <span key={p} className={`absolute ${p} h-3 w-3 border border-copper/60`} />
              ))}
              <div className="absolute bottom-3 left-3 font-mono-caps text-[9px] text-ivory bg-ink-950/70 backdrop-blur px-2 py-1">
                PM · 2026
              </div>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="col-span-12 md:col-span-4 lg:col-span-5 md:pt-4">
            <p className="text-ivory text-xl sm:text-2xl leading-[1.5] font-light font-serif italic">
              I am Parin Majithia &mdash; an architect, second-generation real estate professional and
              developer building my identity in Mumbai&apos;s evolving real-estate landscape.
            </p>
            <div className="mt-10 grid grid-cols-1 gap-6 text-ivory/70 leading-relaxed">
              <p>
                Mumbai-based, with expertise across interior design, architecture, construction and
                property development. A journey that began with a Diploma in Interior Design,
                followed by a Degree in Architecture.
              </p>
              <p>
                This multidisciplinary foundation lets me read every project across five lenses at
                once — design, functionality, execution, market demand and long-term value.
              </p>
              <p>
                Deeply interested in technology, digital innovation and modern real-estate marketing,
                I combine traditional industry experience with a forward-looking approach to creating
                and presenting spaces.
              </p>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-4 border-t border-ivory/[0.08] pt-8">
              {[
                ["12+", "Years across design & RE"],
                ["G+10", "AMI ONE — in build"],
                ["2×", "Consultant of the Year"],
              ].map(([n, l]) => (
                <div key={l}>
                  <div className="font-serif text-3xl md:text-4xl text-ivory">{n}</div>
                  <div className="mt-2 font-mono-caps text-[9px] text-ivory/60">{l}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
